import React from "react";
import {
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
  Container,
  Box
} from "@mui/material";
import { Error as ErrorIcon } from "@mui/icons-material";

interface Props {
  children?: React.ReactNode;
  error?: Error;
}

interface State {
  error?: Error;
}

export class ErrorZone extends React.PureComponent<Props, State> {
  public state: State = {};

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({ error });
  }

  public render() {
    const { children, error: propsError } = this.props;
    const { error: stateError } = this.state;
    const error = stateError ?? propsError ?? undefined;
    if (error) {
      return (
        <Container>
          <Stack alignItems="center">
            <Box height={128} />
            <Box sx={{ width: "50%" }}>
              <Card>
                <CardContent>
                  <Stack alignItems="center" spacing={2}>
                    <ErrorIcon />
                    <Typography variant="body1" gutterBottom>
                      Sorry, something went wrong!
                    </Typography>
                    <Button
                      variant="outlined"
                      onClick={() => window.location.reload()}
                      data-id="button-reload-page"
                    >
                      Try again
                    </Button>
                  </Stack>
                </CardContent>
              </Card>
            </Box>
          </Stack>
        </Container>
      );
    }

    return children;
  }
}
